export const NOT_ALLOWED_FOR_VIEW_PRICE = '$***';

export const DEFAULT_USD_TO_GBP_RATE = 0.9;
